(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["az-cart-jump"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('az-cart-jump')) {
  customElements.define('az-cart-jump', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.onClick = event => {
        const locker = document.querySelector('[data-az-boxnow-country]');
        const target = locker || document.getElementById('main-cart-footer');
        if (target) {
          event.preventDefault();
          target.scrollIntoView({block: 'start'});
          target.setAttribute('tabindex', '-1');target.focus({preventScroll: true});
        }
      };
      this.link.addEventListener('click', this.onClick);
      const checkout = document.getElementById('checkout');
      if (checkout && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {this.hidden = entries[0].isIntersecting;}, {threshold: 0.6});
        this.observer.observe(checkout);
      }
      const footer = document.querySelector('footer');
      if (footer && 'IntersectionObserver' in window) {
        this.footer = new IntersectionObserver(entries => {this.style.visibility = entries[0].isIntersecting ? 'hidden' : '';});
        this.footer.observe(footer);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();this.footer?.disconnect();this.link?.removeEventListener('click', this.onClick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
